export const EXCEL_FORMATS = [
  ".csv",
  "application/vnd.MS-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];
export const IMAGE_FORMATS = [
  "image/png",
  "image/apng",
  "image/avif",
  "image/bmp",
  "image/vnd.microsoft.icon",
  "image/svg+xml",
  "image/gif",
  "image/jpeg",
  "image/tiff",
  "image/webp",
];
export const AUDIO_FORMATS = [
  "audio/aac",
  "audio/midi",
  "audio/x-midi",
  "audio/mpeg",
  "audio/ogg",
  "audio/opus",
  "audio/wav",
  "audio/webm",
  "audio/3gpp",
  "audio/3gpp2",
];
export const VIDEO_FORMATS = [
  "video/x-msvideo",
  ".mp4",
  ".mpeg",
  ".ogg",
  ".mp2t",
  ".webm",
  ".3gpp",
  ".3gpp2",
  ".avi",
  ".mov",
  ".wmv",
];
export const DOCUMENT_FORMATS = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/pdf",
  "application/rtf",
];

export const ZIP_FORMATS = [
  "application/x-7z-compressed",
  ".zip",
  "application/vnd.rar",
  "application/x-tar",
  "application/gzip",
];

export const fileSizeUnit = [
  "Bytes",
  "KB",
  "MB",
  "GB",
  "TB",
  "PB",
  "EB",
  "ZB",
  "YB",
];

export enum IApptTypesEnum {
  LOCAL = "local",
  INTERNATIONAL = "international",
}

export type IDeviceTypes =
  | "thermometer"
  | "glucometer"
  | "ultrasound"
  | "ecg"
  | "stethoscope"
  | "otoscope"
  | "exam-camera"
  | "blood-pressure"
  | "pulse-oximeter"
  | "weight-scale";

export type IResultTypes = "video" | "image" | "audio" | "pdf" | "basic";

export type IVisitFor = "my_self" | "others";

// eslint-disable-next-line @typescript-eslint/naming-convention
export type ID = string | number;

export type IVisitType = "first_visit" | "follow_up_visit";

export type IPatientType = "patient" | "family_member";

export type IApptVisitType = "online_visit" | "in_person_visit";

export type IPhpBoolean = 0 | 1;

export const DEPOSIT_MAX_VALUE = 10_000_000;
